<script>
    import SearchListing from './SearchListing.svelte'
    import { onDestroy, onMount } from 'svelte'
    import { findRepoId } from './helpers'

    const limit = 10

    const list = {
        objects: {
            title: 'Objecten',
            columns: [
                {
                    label: 'ID',
                    field: 'id',
                },
                {
                    label: 'Titel',
                    field: 'title',
                },
                {
                    label: 'Type',
                    field: 'type',
                },
            ],
        },
    }

    const models = {
        list,
    }

    const repoId = findRepoId()

    const parseHash = (hash) => {
        if (hash.indexOf('tree::') === 0) {
            return ['list', 'objects']
        }
        const split = hash.split('@')
        if (!split[0] || !split[1]) {
            return ['list', 'objects']
        }
        return split
    }

    const createOptions = () => {
        const hash = window.location.hash.substring(1)
        let [action, entityType] = parseHash(hash)
        let model = models[action] && models[action][entityType]
        return {
            action,
            entityType,
            model,
        }
    }

    const findId = () => {
        const path = location.pathname.slice(1).replace(/\/edit(#|\/|$)/, '') // Extracts "resources/5995"
        const hash = location.hash.slice(1) // Extracts "tree::archival_object_20385974"

        if (hash.indexOf('@') >= 0) {
            return null
        }

        return encodeURIComponent(path + '#' + hash)
    }

    let options = createOptions()
    let url
    let record
    let intervalId

    onMount(async () => {
        const id = findId()
        url = `https://hub3.digipolis.delving.io/api/arches/search?limit=${limit}&orgID=${repoId}` //`https://hub3.mpm.delving.io/api/arches/search?limit=${limit}&orgID=${repoId}`
        url = id ? `${url}&id=${id}` : url

        const request = await fetch(url)
        record = await request.json()
    })

    onDestroy(() => {
        clearInterval(intervalId)
    })
</script>

{#if options.model && record}
    {#if options.action === 'list'}
        <SearchListing model={options.model} {url} {record} />
    {/if}
{/if}
